import React from "react";
import styled from "styled-components";
// import { data } from "../data/data";
import { HeartStyle } from "../data/data";
import { HeartFilled } from "@ant-design/icons";

const CountContainer = styled.div`
  .banner {
    height: 450px;
    background: linear-gradient(
      rgba(230, 220, 220, 0.7),
      rgba(222, 22, 22, 0.6)
    );
    display: grid;
    place-items: center;
    @media (max-width: 767px) {
      padding: 3px 4%;
      /* font-size: 120%; */
    }
  }

  .banner-text.light {
    color: #fff;
    border-top: medium double #fff;
    border-bottom: medium double #fff;
  }
  .banner-text.medium {
    padding: 7px 50px;
    font-size: 16px;
    font-family: "Oswald", sans-serif;
    margin: 10px 0;
    letter-spacing: 3px;
    transition: all 0.4s ease-in;
    @media (max-width: 767px) {
      padding: 5px 30px;
      font-size: 130%;
      margin: 0 0 25px 0;
      text-align: center;
    }
  }
  .counting,
  .down {
    font-size: 65px;
    line-height: 50px;
    text-align: center;
    color: #fff;
    font-family: "Pacifico";
    width: 100%;
    transform: rotate(-10deg);
    padding-right: 30px;
    margin-top: 0px;
    margin-bottom: 25px;
    @media (max-width: 767px) {
      line-height: 10px;
      font-size: 280%;
      padding: 2px;
    }
  }

  .countdown-section {
    font-size: 16px;
    text-align: center;
    display: flex;
    justify-content: center;
    color: white;
  }
  .countdown-section span {
    margin: 8px;
    padding: 5px;
    font-family: "Pacifico";
  }
`;

export default function CountDown() {
  return (
    <>
      <CountContainer>
        <div className="banner">
          <div style={{ textAlign: "center" }}>
            <p className="banner-text medium light">
              *** AT TRANSCORP HILTON HOTEL, ABUJA ***
            </p>
            <p className="counting">Counting</p>
            <p className="down">Down</p>
            <HeartStyle>
              <span className="white-line"></span>
              <HeartFilled style={{ fontSize: 18, zIndex: 20, color: "red" }} />
              <HeartFilled
                style={{ fontSize: 19, marginLeft: -5, color: "white" }}
              />
              <span className="white-line"></span>
            </HeartStyle>
            <div className="countdown-section">
              <span>23W</span>
              <span>43D</span>
              <span>53M</span>
              <span>13S</span>
            </div>
          </div>
        </div>
      </CountContainer>
    </>
  );
}
